// extracted by mini-css-extract-plugin
export default {"methodDetails":"SelectionMethodToggle_methodDetails__iQy5x","selectionToggle":"SelectionMethodToggle_selectionToggle__qqJOY"};